import MediaGalleryShow from './media-gallery.show';

export default {
  show: MediaGalleryShow,
};
